import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5104b2e2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5104b2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104b2e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5104b2e2')) {
      api.createRecord('5104b2e2', component.options)
    } else {
      api.reload('5104b2e2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5104b2e2&scoped=true&", function () {
      api.rerender('5104b2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navbar/index.vue"
export default component.exports